var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('icon',{staticClass:"animate-reverse-spin-slow h-5 w-5",attrs:{"set":"outline","name":"refresh"}})}
var staticRenderFns = []

export { render, staticRenderFns }